export const enum AWARD_PROGRESS {
  NOT_TRACKING = "notTracking",
  TRACKING = "tracking",
  ACHIEVED = "achieved",
  QUALIFIED = "qualified",
  ON_HOLD = "onHold",
  NOT_ELIGIBLE = "notEligible",
  DENIED = "denied",
  DISQUALIFIED = "disqualified",
}
